import * as React from "react";
const SvgFiRrPlaneDeparture = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-departure_svg__a)">
      <path
        fill="#062147"
        d="m1.067 15.412 2.075 1.476a6.17 6.17 0 0 0 3.572 1.14c.893 0 1.787-.194 2.612-.59l12.953-5.697a3.036 3.036 0 0 0 1.441-4 3.007 3.007 0 0 0-3.976-1.466l-3.143 1.402-6.619-4.086a3 3 0 0 0-3.052-.31l-.781.365A2 2 0 0 0 5.02 5.171a2 2 0 0 0 .654 1.783l4.204 3.72-3.591 1.603-3.057-1.122a2.42 2.42 0 0 0-2.735.79 2.31 2.31 0 0 0-.462 1.777 2.53 2.53 0 0 0 1.033 1.688zM7 5.457l.776-.364c.332-.154.721-.113 1.085.151l5.531 3.418-2.506 1.118zM2.071 13.18a.42.42 0 0 1 .334-.17c.05 0 3.574 1.286 3.574 1.286.245.09.515.08.752-.025l13.833-6.172.013-.006a1.003 1.003 0 0 1 1.328.487c.234.507.016 1.114-.46 1.342L8.492 15.62a4.16 4.16 0 0 1-4.191-.361l-2.075-1.476a.53.53 0 0 1-.213-.348.32.32 0 0 1 .058-.255M24 23a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h22a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-departure_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneDeparture;
